import { render, staticRenderFns } from "./CreateTrip.vue?vue&type=template&id=63eb1f46&scoped=true&"
import script from "./CreateTrip.vue?vue&type=script&lang=js&"
export * from "./CreateTrip.vue?vue&type=script&lang=js&"
import style0 from "./CreateTrip.vue?vue&type=style&index=0&id=63eb1f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb1f46",
  null
  
)

export default component.exports